export default "__VITE_ASSET__BNGPRZgz__"